import { render, staticRenderFns } from "./SwiperExampleSlidesPerColumn.vue?vue&type=template&id=f4a44de2&scoped=true&"
import script from "./SwiperExampleSlidesPerColumn.vue?vue&type=script&lang=js&"
export * from "./SwiperExampleSlidesPerColumn.vue?vue&type=script&lang=js&"
import style0 from "./SwiperExampleSlidesPerColumn.vue?vue&type=style&index=0&id=f4a44de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a44de2",
  null
  
)

export default component.exports